<div class="py-2 px-3">
  <div class="my-2">
    @if (order?.status != 'Cancelled') {
      <button class="mr-2 mt-2" mat-stroked-button color="warn" (click)="setOrderstatusCancel(order.orderId)">Cancellera Order</button>
    }
    @if (order?.status === 'Cancelled') {
      <button class="mr-2 mt-2" mat-stroked-button color="warn" (click)="setOrderstatusPaid(order.orderId)">Återställ Order</button>
    }
    @if (order?.status != 'Cancelled') {
      <button class="mr-2 mt-2" mat-stroked-button color="warn" (click)="sendOrderConfirmation(order.orderId)">Skicka bekräftelse mail</button>
    }
  </div>

  <mat-tab-group dynamicHeight>
    <mat-tab label="Kund">
      <app-back-office24-order-edit [orderId]="orderId" [showAdress]="false"></app-back-office24-order-edit>
    </mat-tab>

    @for (tab of tabList; track tab) {
      <mat-tab label="{{tab.header}}" class="tab-title">
        <app-back-office24-order-shuttle-edit [orderShuttleId]="tab.orderShuttleId" ></app-back-office24-order-shuttle-edit>
      </mat-tab>
    }

  </mat-tab-group>
</div>

